import { render, staticRenderFns } from "./EnergyHour.vue?vue&type=template&id=489dd9d7&scoped=true&"
import script from "./EnergyHour.vue?vue&type=script&lang=js&"
export * from "./EnergyHour.vue?vue&type=script&lang=js&"
import style0 from "./EnergyHour.vue?vue&type=style&index=0&id=489dd9d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489dd9d7",
  null
  
)

export default component.exports